import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b879a09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column justify-between full-height" }
const _hoisted_2 = { class: "row items-center no-wrap" }
const _hoisted_3 = { class: "q-mini-drawer-hide text-left q-pl-sm" }
const _hoisted_4 = { class: "q-mini-drawer-hide" }
const _hoisted_5 = { class: "q-mini-drawer-hide" }
const _hoisted_6 = { class: "q-mini-drawer-hide text-left user-profile-content q-px-xs" }
const _hoisted_7 = { class: "ellipsis" }
const _hoisted_8 = { class: "ellipsis text-grey text-caption" }
const _hoisted_9 = { class: "q-mini-drawer-hide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_logo = _resolveComponent("main-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_creation_menu_content = _resolveComponent("creation-menu-content")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_user_avatar = _resolveComponent("user-avatar")!
  const _component_account_menu_content = _resolveComponent("account-menu-content")!
  const _component_quick_search = _resolveComponent("quick-search")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_scroll_area, {
      class: "col",
      "horizontal-thumb-style": { opacity: '0' },
      "horizontal-bar-style": { opacity: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: { name: _ctx.ROUTE_DATA.HOME_PAGE.name }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_main_logo, {
              class: "menu-item logo-wrapper q-pl-xs",
              "icon-only": _ctx.miniState
            }, null, 8, ["icon-only"])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_q_item, {
          dense: "",
          class: "menu-item no-padding"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, _mergeProps({
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displaySearch = true))
            }, _ctx.BTN_SECONDARY_MD, {
              rounded: "",
              align: "left",
              class: "quick-search full-width bordered",
              "no-wrap": ""
            }), {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_q_icon, {
                    name: _ctx.ICONS_NAME.SEARCH_OUTLINE,
                    size: "xs",
                    color: "blue-dark"
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('QUICK_SEARCH')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }),
        _createVNode(_component_q_list, {
          dense: "",
          class: "left-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.HOME_PAGE.name },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.HOME_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      class: "inactive-icon"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.HOME_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.HOME_SOLID
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('HOME')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "active"]),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.DASHBOARD_HUB_PAGE.name },
              onClick: _ctx.trackDashboardMenu,
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.DASHBOARD_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      class: "inactive-icon"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.CHART_BAR_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.CHART_BAR_SOLID
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('DASHBOARD.CAP.SING')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "onClick", "active"]),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.NETWORK_PAGE.name },
              class: { 'active-link': _ctx.$route.name === _ctx.ROUTE_DATA.NETWORK_PAGE.name }
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      class: "inactive-icon"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.NETWORK_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.NETWORK_SOLID
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('NETWORK')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "class"]),
            _createVNode(_component_q_item, { class: "title" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, _mergeProps({ class: "q-mini-drawer-hide" }, _ctx.TEXT_OVERLINE), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('WORKSPACE')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.BRIEF_HUB_PAGE.name },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.BRIEF_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      class: "inactive-icon",
                      color: "grey-dark"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.FOLDER_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.FOLDER_SOLID,
                      color: "primary"
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('BRIEF.CAP.PLUR')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "active"]),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: {
                        name: _ctx.ROUTE_DATA.LEAD_HUB_PAGE.name
                    },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.LEAD_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({ class: "inactive-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "grey-dark",
                      name: _ctx.ICONS_NAME.FILE_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.FILE_SOLID,
                      color: "primary"
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('LEAD.CAP.PLUR')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "active"]),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.AGREEMENT_HUB_PAGE.name },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.AGREEMENT_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      class: "inactive-icon"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.AGREEMENT_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.AGREEMENT_SOLID_ACTIVE
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('AGREEMENT.CAP.PLUR')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "active"]),
            (_ctx.isAlliance)
              ? (_openBlock(), _createBlock(_component_q_item, _mergeProps({ key: 0 }, _ctx.MENU_ITEM_PROPS, {
                  to: { name: _ctx.ROUTE_DATA.ALLIANCE_HUB_PAGE.name },
                  active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.ALLIANCE_HUB_PAGE.name).includes(_ctx.$route.name.toString())
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, {
                      side: "",
                      class: "q-pa-sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, _mergeProps({
                          color: "grey-dark",
                          class: "inactive-icon"
                        }, _ctx.ICON_PROPS.MAIN_MENU, {
                          name: _ctx.ICONS_NAME.ALLIANCE_OUTLINE
                        }), null, 16, ["name"]),
                        _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                          color: "primary",
                          name: _ctx.ICONS_NAME.ALLIANCE_SOLID_ACTIVE
                        }), null, 16, ["name"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('ALLIANCE.CAP.PLUR')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16, ["to", "active"]))
              : _createCommentVNode("", true),
            (_ctx.isBeta)
              ? (_openBlock(), _createBlock(_component_q_item, _mergeProps({ key: 1 }, _ctx.MENU_ITEM_PROPS, {
                  to: { name: _ctx.ROUTE_DATA.OBLIGATION_HUB_PAGE.name },
                  active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.OBLIGATION_HUB_PAGE.name).includes(_ctx.$route.name.toString())
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, {
                      side: "",
                      class: "q-pa-sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, _mergeProps({
                          color: "grey-dark",
                          class: "inactive-icon"
                        }, _ctx.ICON_PROPS.MAIN_MENU, {
                          name: _ctx.ICONS_NAME.NON_FINANCIAL
                        }), null, 16, ["name"]),
                        _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                          color: "primary",
                          name: _ctx.ICONS_NAME.NON_FINANCIAL_SOLID_ACTIVE
                        }), null, 16, ["name"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('OBLIGATION.CAP.PLUR')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16, ["to", "active"]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item, { class: "title" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, _mergeProps({ class: "q-mini-drawer-hide" }, _ctx.TEXT_OVERLINE), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('DIRECTORY')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.COMPANY_HUB_PAGE.name },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.COMPANY_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      class: "inactive-icon",
                      color: "grey-dark"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.COMPANY_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.COMPANY_SOLID
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('COMPANY.CAP.PLUR')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "active"]),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              onClick: _ctx.trackContactMenu,
              to: { name: _ctx.ROUTE_DATA.CONTACT_HUB_PAGE.name },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.CONTACT_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      class: "inactive-icon"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.CONTACT_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.CONTACT_SOLID
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('CONTACT.CAP.PLUR')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["onClick", "to", "active"]),
            _createVNode(_component_q_item, _mergeProps(_ctx.MENU_ITEM_PROPS, {
              to: { name: _ctx.ROUTE_DATA.MEETING_HUB_PAGE.name },
              active: _ctx.ACTIVE_PAGES.get(_ctx.ROUTE_DATA.MEETING_HUB_PAGE.name).includes(_ctx.$route.name.toString())
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "q-pa-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      class: "inactive-icon"
                    }, _ctx.ICON_PROPS.MAIN_MENU, {
                      name: _ctx.ICONS_NAME.CALENDAR_OUTLINE
                    }), null, 16, ["name"]),
                    _createVNode(_component_q_icon, _mergeProps({ class: "active-icon" }, _ctx.ICON_PROPS.MAIN_MENU, {
                      color: "primary",
                      name: _ctx.ICONS_NAME.CALENDAR_SOLID
                    }), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-mini-drawer-hide q-ml-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('MEETING.CAP.PLUR')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["to", "active"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_separator, { class: "q-mx-lg q-mt-lg" }),
        _createVNode(_component_q_list, {
          dense: "",
          padding: "",
          class: "left-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, { class: "title" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, _mergeProps({ class: "q-mini-drawer-hide" }, _ctx.TEXT_OVERLINE), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('RECENT_BRIEFS', { Briefs: _ctx.t('BRIEF.LOW.PLUR') })), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentBriefList, (brief) => {
              return (_openBlock(), _createBlock(_component_q_item, _mergeProps({
                key: brief.dobjId,
                dense: "",
                style: 'max-width: 201px !important;',
                class: "ellipsis",
                onClick: ($event: any) => (_ctx.redirectToBrief(brief))
              }, _ctx.MENU_ITEM_PROPS), {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    side: "",
                    class: "brief-avatar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, _mergeProps({
                        color: _ctx.getColorName(brief.style, brief?.isArchived),
                        class: "text-uppercase",
                        rounded: ""
                      }, _ctx.AVATAR_PROPS.BRIEF, { "text-color": "white" }), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(brief.name.charAt(0)), 1)
                        ]),
                        _: 2
                      }, 1040, ["color"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, { class: "ellipsis q-mini-drawer-hide q-ml-xs" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, { class: "ellipsis" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(brief.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1040, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_list, { class: "bg-white full-width" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, {
          dense: "",
          class: "q-ma-lg no-padding"
        }, {
          default: _withCtx(() => [
            (_ctx.isContributor)
              ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({ key: 0 }, _ctx.BTN_PRIMARY_MD, {
                  class: "full-width",
                  "no-wrap": "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createLead({ briefId: _ctx.currentBriefId })))
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.ICONS_NAME.PLUS_CIRCLE_SOLID
                    }, null, 8, ["name"]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(`${_ctx.t('ACTION.CREATE')} ${_ctx.t('LEAD.LOW.SING')}`), 1)
                  ]),
                  _: 1
                }, 16))
              : (_openBlock(), _createBlock(_component_q_btn, _mergeProps({ key: 1 }, _ctx.BTN_PRIMARY_MD, {
                  align: "left",
                  class: "full-width",
                  "no-wrap": ""
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.ICONS_NAME.PLUS_CIRCLE_SOLID
                    }, null, 8, ["name"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('ACTION.CREATE')), 1),
                    _createVNode(_component_q_menu, {
                      anchor: "bottom right",
                      self: "bottom left",
                      class: "bordered shadow-3 text-body2 drawer-menu",
                      offset: [8, 0],
                      onBeforeShow: _ctx.disableMiniState,
                      onBeforeHide: _ctx.enableMiniState
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_creation_menu_content)
                      ]),
                      _: 1
                    }, 8, ["onBeforeShow", "onBeforeHide"])
                  ]),
                  _: 1
                }, 16))
          ]),
          _: 1
        }),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_item, {
          dense: "",
          class: "q-ma-md no-padding"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, _mergeProps(_ctx.BTN_TERTIARY_MD, {
              align: "between",
              class: ["full-width", { bordered: !_ctx.miniState }],
              "no-wrap": ""
            }), {
              default: _withCtx(() => [
                _createVNode(_component_user_avatar),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userProfile.firstName) + " " + _toDisplayString(_ctx.userProfile.lastName), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentUser.username), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_q_icon, {
                    name: _ctx.ICONS_NAME.CHEVRON_RIGHT_SOLID,
                    size: "xs",
                    color: "blue-dark"
                  }, null, 8, ["name"])
                ]),
                _createVNode(_component_q_menu, {
                  anchor: "bottom right",
                  self: "bottom left",
                  class: "bordered shadow-3 text-body2 drawer-menu",
                  offset: [8, 0],
                  onBeforeShow: _ctx.userMenuOpen,
                  onBeforeHide: _ctx.userMenuClose
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_account_menu_content)
                  ]),
                  _: 1
                }, 8, ["onBeforeShow", "onBeforeHide"])
              ]),
              _: 1
            }, 16, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      "model-value": _ctx.displaySearch,
      position: "top",
      "transition-hide": "none",
      "transition-show": "none",
      onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displaySearch = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "search-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_quick_search, {
              onCreate: _ctx.createSearch,
              onSearch: _ctx.search
            }, null, 8, ["onCreate", "onSearch"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}